"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ed5 = require("xmlchars/xml/1.0/ed5");

var ed2 = require("xmlchars/xml/1.1/ed2");

var NSed3 = require("xmlchars/xmlns/1.0/ed3");

var isS = ed5.isS;
var isChar10 = ed5.isChar;
var isNameStartChar = ed5.isNameStartChar;
var isNameChar = ed5.isNameChar;
var S_LIST = ed5.S_LIST;
var NAME_RE = ed5.NAME_RE;
var isChar11 = ed2.isChar;
var isNCNameStartChar = NSed3.isNCNameStartChar;
var isNCNameChar = NSed3.isNCNameChar;
var NC_NAME_RE = NSed3.NC_NAME_RE;
var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
var rootNS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  xml: XML_NAMESPACE,
  xmlns: XMLNS_NAMESPACE
};
var XML_ENTITIES = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  amp: "&",
  gt: ">",
  lt: "<",
  quot: "\"",
  apos: "'"
}; // EOC: end-of-chunk

var EOC = -1;
var NL_LIKE = -2;
var S_BEGIN = 0; // Initial state.

var S_BEGIN_WHITESPACE = 1; // leading whitespace

var S_DOCTYPE = 2; // <!DOCTYPE

var S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah

var S_DTD = 4; // <!DOCTYPE "//blah" [ ...

var S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo

var S_DTD_OPEN_WAKA = 6;
var S_DTD_OPEN_WAKA_BANG = 7;
var S_DTD_COMMENT = 8; // <!--

var S_DTD_COMMENT_ENDING = 9; // <!-- blah -

var S_DTD_COMMENT_ENDED = 10; // <!-- blah --

var S_DTD_PI = 11; // <?

var S_DTD_PI_ENDING = 12; // <?hi "there" ?

var S_TEXT = 13; // general stuff

var S_ENTITY = 14; // &amp and such

var S_OPEN_WAKA = 15; // <

var S_OPEN_WAKA_BANG = 16; // <!...

var S_COMMENT = 17; // <!--

var S_COMMENT_ENDING = 18; // <!-- blah -

var S_COMMENT_ENDED = 19; // <!-- blah --

var S_CDATA = 20; // <![CDATA[ something

var S_CDATA_ENDING = 21; // ]

var S_CDATA_ENDING_2 = 22; // ]]

var S_PI_FIRST_CHAR = 23; // <?hi, first char

var S_PI_REST = 24; // <?hi, rest of the name

var S_PI_BODY = 25; // <?hi there

var S_PI_ENDING = 26; // <?hi "there" ?

var S_XML_DECL_NAME_START = 27; // <?xml

var S_XML_DECL_NAME = 28; // <?xml foo

var S_XML_DECL_EQ = 29; // <?xml foo=

var S_XML_DECL_VALUE_START = 30; // <?xml foo=

var S_XML_DECL_VALUE = 31; // <?xml foo="bar"

var S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"

var S_XML_DECL_ENDING = 33; // <?xml ... ?

var S_OPEN_TAG = 34; // <strong

var S_OPEN_TAG_SLASH = 35; // <strong /

var S_ATTRIB = 36; // <a

var S_ATTRIB_NAME = 37; // <a foo

var S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _

var S_ATTRIB_VALUE = 39; // <a foo=

var S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar

var S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"

var S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar

var S_CLOSE_TAG = 43; // </a

var S_CLOSE_TAG_SAW_WHITE = 44; // </a   >

var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
var BANG = 0x21;
var DQUOTE = 0x22;
var AMP = 0x26;
var SQUOTE = 0x27;
var MINUS = 0x2D;
var FORWARD_SLASH = 0x2F;
var SEMICOLON = 0x3B;
var LESS = 0x3C;
var EQUAL = 0x3D;
var GREATER = 0x3E;
var QUESTION = 0x3F;
var OPEN_BRACKET = 0x5B;
var CLOSE_BRACKET = 0x5D;
var NEL = 0x85;
var LS = 0x2028; // Line Separator

var isQuote = function isQuote(c) {
  return c === DQUOTE || c === SQUOTE;
};

var QUOTES = [DQUOTE, SQUOTE];
var DOCTYPE_TERMINATOR = [].concat(QUOTES, [OPEN_BRACKET, GREATER]);
var DTD_TERMINATOR = [].concat(QUOTES, [LESS, CLOSE_BRACKET]);
var XML_DECL_NAME_TERMINATOR = [EQUAL, QUESTION].concat(_toConsumableArray(S_LIST));
var ATTRIB_VALUE_UNQUOTED_TERMINATOR = [].concat(_toConsumableArray(S_LIST), [GREATER, AMP, LESS]);

function nsPairCheck(parser, prefix, uri) {
  switch (prefix) {
    case "xml":
      if (uri !== XML_NAMESPACE) {
        parser.fail("xml prefix must be bound to ".concat(XML_NAMESPACE, "."));
      }

      break;

    case "xmlns":
      if (uri !== XMLNS_NAMESPACE) {
        parser.fail("xmlns prefix must be bound to ".concat(XMLNS_NAMESPACE, "."));
      }

      break;

    default:
  }

  switch (uri) {
    case XMLNS_NAMESPACE:
      parser.fail(prefix === "" ? "the default namespace may not be set to ".concat(uri, ".") : "may not assign a prefix (even \"xmlns\") to the URI ".concat(XMLNS_NAMESPACE, "."));
      break;

    case XML_NAMESPACE:
      switch (prefix) {
        case "xml":
          // Assinging the XML namespace to "xml" is fine.
          break;

        case "":
          parser.fail("the default namespace may not be set to ".concat(uri, "."));
          break;

        default:
          parser.fail("may not assign the xml namespace to another prefix.");
      }

      break;

    default:
  }
}

function nsMappingCheck(parser, mapping) {
  for (var _i = 0, _Object$keys = Object.keys(mapping); _i < _Object$keys.length; _i++) {
    var local = _Object$keys[_i];
    nsPairCheck(parser, local, mapping[local]);
  }
}

var isNCName = function isNCName(name) {
  return NC_NAME_RE.test(name);
};

var isName = function isName(name) {
  return NAME_RE.test(name);
};

var FORBIDDEN_START = 0;
var FORBIDDEN_BRACKET = 1;
var FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */

exports.EVENTS = ["xmldecl", "text", "processinginstruction", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "cdata", "error", "end", "ready"];
var EVENT_NAME_TO_HANDLER_NAME = {
  xmldecl: "xmldeclHandler",
  text: "textHandler",
  processinginstruction: "piHandler",
  doctype: "doctypeHandler",
  comment: "commentHandler",
  opentagstart: "openTagStartHandler",
  attribute: "attributeHandler",
  opentag: "openTagHandler",
  closetag: "closeTagHandler",
  cdata: "cdataHandler",
  error: "errorHandler",
  end: "endHandler",
  ready: "readyHandler"
};

var SaxesParser = /*#__PURE__*/function () {
  /**
   * @param opt The parser options.
   */
  function SaxesParser(opt) {
    _classCallCheck(this, SaxesParser);

    this.opt = opt !== null && opt !== void 0 ? opt : {};
    this.fragmentOpt = !!this.opt.fragment;
    var xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
    this.trackPosition = this.opt.position !== false;
    this.fileName = this.opt.fileName;

    if (xmlnsOpt) {
      // This is the function we use to perform name checks on PIs and entities.
      // When namespaces are used, colons are not allowed in PI target names or
      // entity names. So the check depends on whether namespaces are used. See:
      //
      // https://www.w3.org/XML/xml-names-19990114-errata.html
      // NE08
      //
      this.nameStartCheck = isNCNameStartChar;
      this.nameCheck = isNCNameChar;
      this.isName = isNCName; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.processAttribs = this.processAttribsNS; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.pushAttrib = this.pushAttribNS; // eslint-disable-next-line @typescript-eslint/no-explicit-any

      this.ns = Object.assign({
        __proto__: null
      }, rootNS);
      var additional = this.opt.additionalNamespaces;

      if (additional != null) {
        nsMappingCheck(this, additional);
        Object.assign(this.ns, additional);
      }
    } else {
      this.nameStartCheck = isNameStartChar;
      this.nameCheck = isNameChar;
      this.isName = isName; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.processAttribs = this.processAttribsPlain; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.pushAttrib = this.pushAttribPlain;
    } //
    // The order of the members in this table needs to correspond to the state
    // numbers given to the states that correspond to the methods being recorded
    // here.
    //


    this.stateTable = [
    /* eslint-disable @typescript-eslint/unbound-method */
    this.sBegin, this.sBeginWhitespace, this.sDoctype, this.sDoctypeQuote, this.sDTD, this.sDTDQuoted, this.sDTDOpenWaka, this.sDTDOpenWakaBang, this.sDTDComment, this.sDTDCommentEnding, this.sDTDCommentEnded, this.sDTDPI, this.sDTDPIEnding, this.sText, this.sEntity, this.sOpenWaka, this.sOpenWakaBang, this.sComment, this.sCommentEnding, this.sCommentEnded, this.sCData, this.sCDataEnding, this.sCDataEnding2, this.sPIFirstChar, this.sPIRest, this.sPIBody, this.sPIEnding, this.sXMLDeclNameStart, this.sXMLDeclName, this.sXMLDeclEq, this.sXMLDeclValueStart, this.sXMLDeclValue, this.sXMLDeclSeparator, this.sXMLDeclEnding, this.sOpenTag, this.sOpenTagSlash, this.sAttrib, this.sAttribName, this.sAttribNameSawWhite, this.sAttribValue, this.sAttribValueQuoted, this.sAttribValueClosed, this.sAttribValueUnquoted, this.sCloseTag, this.sCloseTagSawWhite];

    this._init();
  }
  /**
   * Indicates whether or not the parser is closed. If ``true``, wait for
   * the ``ready`` event to write again.
   */


  _createClass(SaxesParser, [{
    key: "closed",
    get: function get() {
      return this._closed;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _a;

      this.openWakaBang = "";
      this.text = "";
      this.name = "";
      this.piTarget = "";
      this.entity = "";
      this.q = null;
      this.tags = [];
      this.tag = null;
      this.topNS = null;
      this.chunk = "";
      this.chunkPosition = 0;
      this.i = 0;
      this.prevI = 0;
      this.carriedFromPrevious = undefined;
      this.forbiddenState = FORBIDDEN_START;
      this.attribList = []; // The logic is organized so as to minimize the need to check
      // this.opt.fragment while parsing.

      var fragmentOpt = this.fragmentOpt;
      this.state = fragmentOpt ? S_TEXT : S_BEGIN; // We want these to be all true if we are dealing with a fragment.

      this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt; // An XML declaration is intially possible only when parsing whole
      // documents.

      this.xmlDeclPossible = !fragmentOpt;
      this.xmlDeclExpects = ["version"];
      this.entityReturnState = undefined;
      var defaultXMLVersion = this.opt.defaultXMLVersion;

      if (defaultXMLVersion === undefined) {
        if (this.opt.forceXMLVersion === true) {
          throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
        }

        defaultXMLVersion = "1.0";
      }

      this.setXMLVersion(defaultXMLVersion);
      this.positionAtNewLine = 0;
      this.doctype = false;
      this._closed = false;
      this.xmlDecl = {
        version: undefined,
        encoding: undefined,
        standalone: undefined
      };
      this.line = 1;
      this.column = 0;
      this.ENTITIES = Object.create(XML_ENTITIES); // eslint-disable-next-line no-unused-expressions

      (_a = this.readyHandler) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */

  }, {
    key: "position",
    get: function get() {
      return this.chunkPosition + this.i;
    }
    /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */

  }, {
    key: "columnIndex",
    get: function get() {
      return this.position - this.positionAtNewLine;
    }
    /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */

  }, {
    key: "on",
    value: function on(name, handler) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
    }
    /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */

  }, {
    key: "off",
    value: function off(name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
    }
    /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */

  }, {
    key: "makeError",
    value: function makeError(message) {
      var _a;

      var msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";

      if (this.trackPosition) {
        if (msg.length > 0) {
          msg += ":";
        }

        msg += "".concat(this.line, ":").concat(this.column);
      }

      if (msg.length > 0) {
        msg += ": ";
      }

      return new Error(msg + message);
    }
    /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */

  }, {
    key: "fail",
    value: function fail(message) {
      var err = this.makeError(message);
      var handler = this.errorHandler;

      if (handler === undefined) {
        throw err;
      } else {
        handler(err);
      }

      return this;
    }
    /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */

  }, {
    key: "write",
    value: function write(chunk) {
      if (this.closed) {
        return this.fail("cannot write after close; assign an onready handler.");
      }

      var end = false;

      if (chunk === null) {
        // We cannot return immediately because carriedFromPrevious may need
        // processing.
        end = true;
        chunk = "";
      } else if (_typeof(chunk) === "object") {
        chunk = chunk.toString();
      } // We checked if performing a pre-decomposition of the string into an array
      // of single complete characters (``Array.from(chunk)``) would be faster
      // than the current repeated calls to ``charCodeAt``. As of August 2018, it
      // isn't. (There may be Node-specific code that would perform faster than
      // ``Array.from`` but don't want to be dependent on Node.)


      if (this.carriedFromPrevious !== undefined) {
        // The previous chunk had char we must carry over.
        chunk = "".concat(this.carriedFromPrevious).concat(chunk);
        this.carriedFromPrevious = undefined;
      }

      var limit = chunk.length;
      var lastCode = chunk.charCodeAt(limit - 1);

      if (!end && ( // A trailing CR or surrogate must be carried over to the next
      // chunk.
      lastCode === CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
        // The chunk ends with a character that must be carried over. We cannot
        // know how to handle it until we get the next chunk or the end of the
        // stream. So save it for later.
        this.carriedFromPrevious = chunk[limit - 1];
        limit--;
        chunk = chunk.slice(0, limit);
      }

      var stateTable = this.stateTable;
      this.chunk = chunk;
      this.i = 0;

      while (this.i < limit) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        stateTable[this.state].call(this);
      }

      this.chunkPosition += limit;
      return end ? this.end() : this;
    }
    /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */

  }, {
    key: "close",
    value: function close() {
      return this.write(null);
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */

  }, {
    key: "getCode10",
    value: function getCode10() {
      var chunk = this.chunk,
          i = this.i;
      this.prevI = i; // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.

      this.i = i + 1;

      if (i >= chunk.length) {
        return EOC;
      } // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.


      var code = chunk.charCodeAt(i);
      this.column++;

      if (code < 0xD800) {
        if (code >= SPACE || code === TAB) {
          return code;
        }

        switch (code) {
          case NL:
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;

          case CR:
            // We may get NaN if we read past the end of the chunk, which is fine.
            if (chunk.charCodeAt(i + 1) === NL) {
              // A \r\n sequence is converted to \n so we have to skip over the
              // next character. We already know it has a size of 1 so ++ is fine
              // here.
              this.i = i + 2;
            } // Otherwise, a \r is just converted to \n, so we don't have to skip
            // ahead.
            // In either case, \r becomes \n.


            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;

          default:
            // If we get here, then code < SPACE and it is not NL CR or TAB.
            this.fail("disallowed character.");
            return code;
        }
      }

      if (code > 0xDBFF) {
        // This is a specialized version of isChar10 that takes into account
        // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
        // test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }

        return code;
      }

      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2; // This is a specialized version of isChar10 that takes into account that in
      // this context necessarily final >= 0x10000.

      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }

      return final;
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */

  }, {
    key: "getCode11",
    value: function getCode11() {
      var chunk = this.chunk,
          i = this.i;
      this.prevI = i; // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.

      this.i = i + 1;

      if (i >= chunk.length) {
        return EOC;
      } // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.


      var code = chunk.charCodeAt(i);
      this.column++;

      if (code < 0xD800) {
        if (code > 0x1F && code < 0x7F || code > 0x9F && code !== LS || code === TAB) {
          return code;
        }

        switch (code) {
          case NL:
            // 0xA
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;

          case CR:
            {
              // 0xD
              // We may get NaN if we read past the end of the chunk, which is
              // fine.
              var next = chunk.charCodeAt(i + 1);

              if (next === NL || next === NEL) {
                // A CR NL or CR NEL sequence is converted to NL so we have to skip
                // over the next character. We already know it has a size of 1.
                this.i = i + 2;
              } // Otherwise, a CR is just converted to NL, no skip.

            }

          /* yes, fall through */

          case NEL: // 0x85

          case LS:
            // Ox2028
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;

          default:
            this.fail("disallowed character.");
            return code;
        }
      }

      if (code > 0xDBFF) {
        // This is a specialized version of isCharAndNotRestricted that takes into
        // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
        // does not test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }

        return code;
      }

      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2; // This is a specialized version of isCharAndNotRestricted that takes into
      // account that in this context necessarily final >= 0x10000.

      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }

      return final;
    }
    /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */

  }, {
    key: "getCodeNorm",
    value: function getCodeNorm() {
      var c = this.getCode();
      return c === NL_LIKE ? NL : c;
    }
  }, {
    key: "unget",
    value: function unget() {
      this.i = this.prevI;
      this.column--;
    }
    /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */

  }, {
    key: "captureTo",
    value: function captureTo(chars) {
      var start = this.i;
      var chunk = this.chunk; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCode();
        var isNLLike = c === NL_LIKE;
        var final = isNLLike ? NL : c;

        if (final === EOC || chars.includes(final)) {
          this.text += chunk.slice(start, this.prevI);
          return final;
        }

        if (isNLLike) {
          this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          start = this.i;
        }
      }
    }
    /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */

  }, {
    key: "captureToChar",
    value: function captureToChar(char) {
      var start = this.i;
      var chunk = this.chunk; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCode();

        switch (c) {
          case NL_LIKE:
            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            c = NL;
            break;

          case EOC:
            this.text += chunk.slice(start);
            return false;

          default:
        }

        if (c === char) {
          this.text += chunk.slice(start, this.prevI);
          return true;
        }
      }
    }
    /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */

  }, {
    key: "captureNameChars",
    value: function captureNameChars() {
      var chunk = this.chunk,
          start = this.i; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCode();

        if (c === EOC) {
          this.name += chunk.slice(start);
          return EOC;
        } // NL is not a name char so we don't have to test specifically for it.


        if (!isNameChar(c)) {
          this.name += chunk.slice(start, this.prevI);
          return c === NL_LIKE ? NL : c;
        }
      }
    }
    /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */

  }, {
    key: "skipSpaces",
    value: function skipSpaces() {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();

        if (c === EOC || !isS(c)) {
          return c;
        }
      }
    }
  }, {
    key: "setXMLVersion",
    value: function setXMLVersion(version) {
      this.currentXMLVersion = version;
      /*  eslint-disable @typescript-eslint/unbound-method */

      if (version === "1.0") {
        this.isChar = isChar10;
        this.getCode = this.getCode10;
      } else {
        this.isChar = isChar11;
        this.getCode = this.getCode11;
      }
      /* eslint-enable @typescript-eslint/unbound-method */

    } // STATE ENGINE METHODS
    // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
    // to be sure never to come back to this state later.

  }, {
    key: "sBegin",
    value: function sBegin() {
      // We are essentially peeking at the first character of the chunk. Since
      // S_BEGIN can be in effect only when we start working on the first chunk,
      // the index at which we must look is necessarily 0. Note also that the
      // following test does not depend on decoding surrogates.
      // If the initial character is 0xFEFF, ignore it.
      if (this.chunk.charCodeAt(0) === 0xFEFF) {
        this.i++;
        this.column++;
      }

      this.state = S_BEGIN_WHITESPACE;
    }
  }, {
    key: "sBeginWhitespace",
    value: function sBeginWhitespace() {
      // We need to know whether we've encountered spaces or not because as soon
      // as we run into a space, an XML declaration is no longer possible. Rather
      // than slow down skipSpaces even in places where we don't care whether it
      // skipped anything or not, we check whether prevI is equal to the value of
      // i from before we skip spaces.
      var iBefore = this.i;
      var c = this.skipSpaces();

      if (this.prevI !== iBefore) {
        this.xmlDeclPossible = false;
      }

      switch (c) {
        case LESS:
          this.state = S_OPEN_WAKA; // We could naively call closeText but in this state, it is not normal
          // to have text be filled with any data.

          if (this.text.length !== 0) {
            throw new Error("no-empty text at start");
          }

          break;

        case EOC:
          break;

        default:
          this.unget();
          this.state = S_TEXT;
          this.xmlDeclPossible = false;
      }
    }
  }, {
    key: "sDoctype",
    value: function sDoctype() {
      var _a;

      var c = this.captureTo(DOCTYPE_TERMINATOR);

      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.doctypeHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            this.doctype = true; // just remember that we saw it.

            break;
          }

        case EOC:
          break;

        default:
          this.text += String.fromCodePoint(c);

          if (c === OPEN_BRACKET) {
            this.state = S_DTD;
          } else if (isQuote(c)) {
            this.state = S_DOCTYPE_QUOTE;
            this.q = c;
          }

      }
    }
  }, {
    key: "sDoctypeQuote",
    value: function sDoctypeQuote() {
      var q = this.q;

      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.q = null;
        this.state = S_DOCTYPE;
      }
    }
  }, {
    key: "sDTD",
    value: function sDTD() {
      var c = this.captureTo(DTD_TERMINATOR);

      if (c === EOC) {
        return;
      }

      this.text += String.fromCodePoint(c);

      if (c === CLOSE_BRACKET) {
        this.state = S_DOCTYPE;
      } else if (c === LESS) {
        this.state = S_DTD_OPEN_WAKA;
      } else if (isQuote(c)) {
        this.state = S_DTD_QUOTED;
        this.q = c;
      }
    }
  }, {
    key: "sDTDQuoted",
    value: function sDTDQuoted() {
      var q = this.q;

      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.state = S_DTD;
        this.q = null;
      }
    }
  }, {
    key: "sDTDOpenWaka",
    value: function sDTDOpenWaka() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);

      switch (c) {
        case BANG:
          this.state = S_DTD_OPEN_WAKA_BANG;
          this.openWakaBang = "";
          break;

        case QUESTION:
          this.state = S_DTD_PI;
          break;

        default:
          this.state = S_DTD;
      }
    }
  }, {
    key: "sDTDOpenWakaBang",
    value: function sDTDOpenWakaBang() {
      var char = String.fromCodePoint(this.getCodeNorm());
      var owb = this.openWakaBang += char;
      this.text += char;

      if (owb !== "-") {
        this.state = owb === "--" ? S_DTD_COMMENT : S_DTD;
        this.openWakaBang = "";
      }
    }
  }, {
    key: "sDTDComment",
    value: function sDTDComment() {
      if (this.captureToChar(MINUS)) {
        this.text += "-";
        this.state = S_DTD_COMMENT_ENDING;
      }
    }
  }, {
    key: "sDTDCommentEnding",
    value: function sDTDCommentEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      this.state = c === MINUS ? S_DTD_COMMENT_ENDED : S_DTD_COMMENT;
    }
  }, {
    key: "sDTDCommentEnded",
    value: function sDTDCommentEnded() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);

      if (c === GREATER) {
        this.state = S_DTD;
      } else {
        this.fail("malformed comment."); // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "

        this.state = S_DTD_COMMENT;
      }
    }
  }, {
    key: "sDTDPI",
    value: function sDTDPI() {
      if (this.captureToChar(QUESTION)) {
        this.text += "?";
        this.state = S_DTD_PI_ENDING;
      }
    }
  }, {
    key: "sDTDPIEnding",
    value: function sDTDPIEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);

      if (c === GREATER) {
        this.state = S_DTD;
      }
    }
  }, {
    key: "sText",
    value: function sText() {
      //
      // We did try a version of saxes where the S_TEXT state was split in two
      // states: one for text inside the root element, and one for text
      // outside. This was avoiding having to test this.tags.length to decide
      // what implementation to actually use.
      //
      // Peformance testing on gigabyte-size files did not show any advantage to
      // using the two states solution instead of the current one. Conversely, it
      // made the code a bit more complicated elsewhere. For instance, a comment
      // can appear before the root element so when a comment ended it was
      // necessary to determine whether to return to the S_TEXT state or to the
      // new text-outside-root state.
      //
      if (this.tags.length !== 0) {
        this.handleTextInRoot();
      } else {
        this.handleTextOutsideRoot();
      }
    }
  }, {
    key: "sEntity",
    value: function sEntity() {
      // This is essentially a specialized version of captureToChar(SEMICOLON...)
      var start = this.i;
      var chunk = this.chunk; // eslint-disable-next-line no-labels, no-restricted-syntax

      loop: // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case NL_LIKE:
            this.entity += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            break;

          case SEMICOLON:
            {
              var entityReturnState = this.entityReturnState;
              var entity = this.entity + chunk.slice(start, this.prevI);
              this.state = entityReturnState;
              var parsed = void 0;

              if (entity === "") {
                this.fail("empty entity name.");
                parsed = "&;";
              } else {
                parsed = this.parseEntity(entity);
                this.entity = "";
              }

              if (entityReturnState !== S_TEXT || this.textHandler !== undefined) {
                this.text += parsed;
              } // eslint-disable-next-line no-labels


              break loop;
            }

          case EOC:
            this.entity += chunk.slice(start); // eslint-disable-next-line no-labels

            break loop;

          default:
        }
      }
    }
  }, {
    key: "sOpenWaka",
    value: function sOpenWaka() {
      // Reminder: a state handler is called with at least one character
      // available in the current chunk. So the first call to get code inside of
      // a state handler cannot return ``EOC``. That's why we don't test
      // for it.
      var c = this.getCode(); // either a /, ?, !, or text is coming next.

      if (isNameStartChar(c)) {
        this.state = S_OPEN_TAG;
        this.unget();
        this.xmlDeclPossible = false;
      } else {
        switch (c) {
          case FORWARD_SLASH:
            this.state = S_CLOSE_TAG;
            this.xmlDeclPossible = false;
            break;

          case BANG:
            this.state = S_OPEN_WAKA_BANG;
            this.openWakaBang = "";
            this.xmlDeclPossible = false;
            break;

          case QUESTION:
            this.state = S_PI_FIRST_CHAR;
            break;

          default:
            this.fail("disallowed character in tag name");
            this.state = S_TEXT;
            this.xmlDeclPossible = false;
        }
      }
    }
  }, {
    key: "sOpenWakaBang",
    value: function sOpenWakaBang() {
      this.openWakaBang += String.fromCodePoint(this.getCodeNorm());

      switch (this.openWakaBang) {
        case "[CDATA[":
          if (!this.sawRoot && !this.reportedTextBeforeRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextBeforeRoot = true;
          }

          if (this.closedRoot && !this.reportedTextAfterRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextAfterRoot = true;
          }

          this.state = S_CDATA;
          this.openWakaBang = "";
          break;

        case "--":
          this.state = S_COMMENT;
          this.openWakaBang = "";
          break;

        case "DOCTYPE":
          this.state = S_DOCTYPE;

          if (this.doctype || this.sawRoot) {
            this.fail("inappropriately located doctype declaration.");
          }

          this.openWakaBang = "";
          break;

        default:
          // 7 happens to be the maximum length of the string that can possibly
          // match one of the cases above.
          if (this.openWakaBang.length >= 7) {
            this.fail("incorrect syntax.");
          }

      }
    }
  }, {
    key: "sComment",
    value: function sComment() {
      if (this.captureToChar(MINUS)) {
        this.state = S_COMMENT_ENDING;
      }
    }
  }, {
    key: "sCommentEnding",
    value: function sCommentEnding() {
      var _a;

      var c = this.getCodeNorm();

      if (c === MINUS) {
        this.state = S_COMMENT_ENDED; // eslint-disable-next-line no-unused-expressions

        (_a = this.commentHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
        this.text = "";
      } else {
        this.text += "-".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      }
    }
  }, {
    key: "sCommentEnded",
    value: function sCommentEnded() {
      var c = this.getCodeNorm();

      if (c !== GREATER) {
        this.fail("malformed comment."); // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "

        this.text += "--".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      } else {
        this.state = S_TEXT;
      }
    }
  }, {
    key: "sCData",
    value: function sCData() {
      if (this.captureToChar(CLOSE_BRACKET)) {
        this.state = S_CDATA_ENDING;
      }
    }
  }, {
    key: "sCDataEnding",
    value: function sCDataEnding() {
      var c = this.getCodeNorm();

      if (c === CLOSE_BRACKET) {
        this.state = S_CDATA_ENDING_2;
      } else {
        this.text += "]".concat(String.fromCodePoint(c));
        this.state = S_CDATA;
      }
    }
  }, {
    key: "sCDataEnding2",
    value: function sCDataEnding2() {
      var _a;

      var c = this.getCodeNorm();

      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.cdataHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            break;
          }

        case CLOSE_BRACKET:
          this.text += "]";
          break;

        default:
          this.text += "]]".concat(String.fromCodePoint(c));
          this.state = S_CDATA;
      }
    } // We need this separate state to check the first character fo the pi target
    // with this.nameStartCheck which allows less characters than this.nameCheck.

  }, {
    key: "sPIFirstChar",
    value: function sPIFirstChar() {
      var c = this.getCodeNorm(); // This is first because in the case where the file is well-formed this is
      // the branch taken. We optimize for well-formedness.

      if (this.nameStartCheck(c)) {
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      } else if (c === QUESTION || isS(c)) {
        this.fail("processing instruction without a target.");
        this.state = c === QUESTION ? S_PI_ENDING : S_PI_BODY;
      } else {
        this.fail("disallowed character in processing instruction name.");
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      }
    }
  }, {
    key: "sPIRest",
    value: function sPIRest() {
      // Capture characters into a piTarget while ``this.nameCheck`` run on the
      // character read returns true.
      var chunk = this.chunk,
          start = this.i; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCodeNorm();

        if (c === EOC) {
          this.piTarget += chunk.slice(start);
          return;
        } // NL cannot satisfy this.nameCheck so we don't have to test specifically
        // for it.


        if (!this.nameCheck(c)) {
          this.piTarget += chunk.slice(start, this.prevI);
          var isQuestion = c === QUESTION;

          if (isQuestion || isS(c)) {
            if (this.piTarget === "xml") {
              if (!this.xmlDeclPossible) {
                this.fail("an XML declaration must be at the start of the document.");
              }

              this.state = isQuestion ? S_XML_DECL_ENDING : S_XML_DECL_NAME_START;
            } else {
              this.state = isQuestion ? S_PI_ENDING : S_PI_BODY;
            }
          } else {
            this.fail("disallowed character in processing instruction name.");
            this.piTarget += String.fromCodePoint(c);
          }

          break;
        }
      }
    }
  }, {
    key: "sPIBody",
    value: function sPIBody() {
      if (this.text.length === 0) {
        var c = this.getCodeNorm();

        if (c === QUESTION) {
          this.state = S_PI_ENDING;
        } else if (!isS(c)) {
          this.text = String.fromCodePoint(c);
        }
      } // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      else if (this.captureToChar(QUESTION)) {
          this.state = S_PI_ENDING;
        }
    }
  }, {
    key: "sPIEnding",
    value: function sPIEnding() {
      var _a;

      var c = this.getCodeNorm();

      if (c === GREATER) {
        var piTarget = this.piTarget;

        if (piTarget.toLowerCase() === "xml") {
          this.fail("the XML declaration must appear at the start of the document.");
        } // eslint-disable-next-line no-unused-expressions


        (_a = this.piHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
          target: piTarget,
          body: this.text
        });
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else if (c === QUESTION) {
        // We ran into ?? as part of a processing instruction. We initially took
        // the first ? as a sign that the PI was ending, but it is not. So we have
        // to add it to the body but we take the new ? as a sign that the PI is
        // ending.
        this.text += "?";
      } else {
        this.text += "?".concat(String.fromCodePoint(c));
        this.state = S_PI_BODY;
      }

      this.xmlDeclPossible = false;
    }
  }, {
    key: "sXMLDeclNameStart",
    value: function sXMLDeclNameStart() {
      var c = this.skipSpaces(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }

      if (c !== EOC) {
        this.state = S_XML_DECL_NAME;
        this.name = String.fromCodePoint(c);
      }
    }
  }, {
    key: "sXMLDeclName",
    value: function sXMLDeclName() {
      var c = this.captureTo(XML_DECL_NAME_TERMINATOR); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.name += this.text;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (!(isS(c) || c === EQUAL)) {
        return;
      }

      this.name += this.text;
      this.text = "";

      if (!this.xmlDeclExpects.includes(this.name)) {
        switch (this.name.length) {
          case 0:
            this.fail("did not expect any more name/value pairs.");
            break;

          case 1:
            this.fail("expected the name ".concat(this.xmlDeclExpects[0], "."));
            break;

          default:
            this.fail("expected one of ".concat(this.xmlDeclExpects.join(", ")));
        }
      }

      this.state = c === EQUAL ? S_XML_DECL_VALUE_START : S_XML_DECL_EQ;
    }
  }, {
    key: "sXMLDeclEq",
    value: function sXMLDeclEq() {
      var c = this.getCodeNorm(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (isS(c)) {
        return;
      }

      if (c !== EQUAL) {
        this.fail("value required.");
      }

      this.state = S_XML_DECL_VALUE_START;
    }
  }, {
    key: "sXMLDeclValueStart",
    value: function sXMLDeclValueStart() {
      var c = this.getCodeNorm(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (isS(c)) {
        return;
      }

      if (!isQuote(c)) {
        this.fail("value must be quoted.");
        this.q = SPACE;
      } else {
        this.q = c;
      }

      this.state = S_XML_DECL_VALUE;
    }
  }, {
    key: "sXMLDeclValue",
    value: function sXMLDeclValue() {
      var c = this.captureTo([this.q, QUESTION]); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (c === EOC) {
        return;
      }

      var value = this.text;
      this.text = "";

      switch (this.name) {
        case "version":
          {
            this.xmlDeclExpects = ["encoding", "standalone"];
            var version = value;
            this.xmlDecl.version = version; // This is the test specified by XML 1.0 but it is fine for XML 1.1.

            if (!/^1\.[0-9]+$/.test(version)) {
              this.fail("version number must match /^1\\.[0-9]+$/.");
            } // When forceXMLVersion is set, the XML declaration is ignored.
            else if (!this.opt.forceXMLVersion) {
                this.setXMLVersion(version);
              }

            break;
          }

        case "encoding":
          if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) {
            this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
          }

          this.xmlDeclExpects = ["standalone"];
          this.xmlDecl.encoding = value;
          break;

        case "standalone":
          if (value !== "yes" && value !== "no") {
            this.fail("standalone value must match \"yes\" or \"no\".");
          }

          this.xmlDeclExpects = [];
          this.xmlDecl.standalone = value;
          break;

        default: // We don't need to raise an error here since we've already raised one
        // when checking what name was expected.

      }

      this.name = "";
      this.state = S_XML_DECL_SEPARATOR;
    }
  }, {
    key: "sXMLDeclSeparator",
    value: function sXMLDeclSeparator() {
      var c = this.getCodeNorm(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }

      if (!isS(c)) {
        this.fail("whitespace required.");
        this.unget();
      }

      this.state = S_XML_DECL_NAME_START;
    }
  }, {
    key: "sXMLDeclEnding",
    value: function sXMLDeclEnding() {
      var _a;

      var c = this.getCodeNorm();

      if (c === GREATER) {
        if (this.piTarget !== "xml") {
          this.fail("processing instructions are not allowed before root.");
        } else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) {
          this.fail("XML declaration must contain a version.");
        } // eslint-disable-next-line no-unused-expressions


        (_a = this.xmldeclHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.xmlDecl);
        this.name = "";
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else {
        // We got here because the previous character was a ?, but the question
        // mark character is not valid inside any of the XML declaration
        // name/value pairs.
        this.fail("The character ? is disallowed anywhere in XML declarations.");
      }

      this.xmlDeclPossible = false;
    }
  }, {
    key: "sOpenTag",
    value: function sOpenTag() {
      var _a;

      var c = this.captureNameChars();

      if (c === EOC) {
        return;
      }

      var tag = this.tag = {
        name: this.name,
        attributes: Object.create(null)
      };
      this.name = "";

      if (this.xmlnsOpt) {
        this.topNS = tag.ns = Object.create(null);
      } // eslint-disable-next-line no-unused-expressions


      (_a = this.openTagStartHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      this.sawRoot = true;

      if (!this.fragmentOpt && this.closedRoot) {
        this.fail("documents may contain only one root.");
      }

      switch (c) {
        case GREATER:
          this.openTag();
          break;

        case FORWARD_SLASH:
          this.state = S_OPEN_TAG_SLASH;
          break;

        default:
          if (!isS(c)) {
            this.fail("disallowed character in tag name.");
          }

          this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sOpenTagSlash",
    value: function sOpenTagSlash() {
      if (this.getCode() === GREATER) {
        this.openSelfClosingTag();
      } else {
        this.fail("forward-slash in opening tag not followed by >.");
        this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sAttrib",
    value: function sAttrib() {
      var c = this.skipSpaces();

      if (c === EOC) {
        return;
      }

      if (isNameStartChar(c)) {
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribName",
    value: function sAttribName() {
      var c = this.captureNameChars();

      if (c === EQUAL) {
        this.state = S_ATTRIB_VALUE;
      } else if (isS(c)) {
        this.state = S_ATTRIB_NAME_SAW_WHITE;
      } else if (c === GREATER) {
        this.fail("attribute without value.");
        this.pushAttrib(this.name, this.name);
        this.name = this.text = "";
        this.openTag();
      } else if (c !== EOC) {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribNameSawWhite",
    value: function sAttribNameSawWhite() {
      var c = this.skipSpaces();

      switch (c) {
        case EOC:
          return;

        case EQUAL:
          this.state = S_ATTRIB_VALUE;
          break;

        default:
          this.fail("attribute without value."); // Should we do this???
          // this.tag.attributes[this.name] = "";

          this.text = "";
          this.name = "";

          if (c === GREATER) {
            this.openTag();
          } else if (isNameStartChar(c)) {
            this.unget();
            this.state = S_ATTRIB_NAME;
          } else {
            this.fail("disallowed character in attribute name.");
            this.state = S_ATTRIB;
          }

      }
    }
  }, {
    key: "sAttribValue",
    value: function sAttribValue() {
      var c = this.getCodeNorm();

      if (isQuote(c)) {
        this.q = c;
        this.state = S_ATTRIB_VALUE_QUOTED;
      } else if (!isS(c)) {
        this.fail("unquoted attribute value.");
        this.state = S_ATTRIB_VALUE_UNQUOTED;
        this.unget();
      }
    }
  }, {
    key: "sAttribValueQuoted",
    value: function sAttribValueQuoted() {
      // We deliberately do not use captureTo here. The specialized code we use
      // here is faster than using captureTo.
      var q = this.q,
          chunk = this.chunk;
      var start = this.i; // eslint-disable-next-line no-constant-condition

      while (true) {
        switch (this.getCode()) {
          case q:
            this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
            this.name = this.text = "";
            this.q = null;
            this.state = S_ATTRIB_VALUE_CLOSED;
            return;

          case AMP:
            this.text += chunk.slice(start, this.prevI);
            this.state = S_ENTITY;
            this.entityReturnState = S_ATTRIB_VALUE_QUOTED;
            return;

          case NL:
          case NL_LIKE:
          case TAB:
            this.text += "".concat(chunk.slice(start, this.prevI), " ");
            start = this.i;
            break;

          case LESS:
            this.text += chunk.slice(start, this.prevI);
            this.fail("disallowed character.");
            return;

          case EOC:
            this.text += chunk.slice(start);
            return;

          default:
        }
      }
    }
  }, {
    key: "sAttribValueClosed",
    value: function sAttribValueClosed() {
      var c = this.getCodeNorm();

      if (isS(c)) {
        this.state = S_ATTRIB;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else if (isNameStartChar(c)) {
        this.fail("no whitespace between attributes.");
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribValueUnquoted",
    value: function sAttribValueUnquoted() {
      // We don't do anything regarding EOL or space handling for unquoted
      // attributes. We already have failed by the time we get here, and the
      // contract that saxes upholds states that upon failure, it is not safe to
      // rely on the data passed to event handlers (other than
      // ``onerror``). Passing "bad" data is not a problem.
      var c = this.captureTo(ATTRIB_VALUE_UNQUOTED_TERMINATOR);

      switch (c) {
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_ATTRIB_VALUE_UNQUOTED;
          break;

        case LESS:
          this.fail("disallowed character.");
          break;

        case EOC:
          break;

        default:
          if (this.text.includes("]]>")) {
            this.fail("the string \"]]>\" is disallowed in char data.");
          }

          this.pushAttrib(this.name, this.text);
          this.name = this.text = "";

          if (c === GREATER) {
            this.openTag();
          } else {
            this.state = S_ATTRIB;
          }

      }
    }
  }, {
    key: "sCloseTag",
    value: function sCloseTag() {
      var c = this.captureNameChars();

      if (c === GREATER) {
        this.closeTag();
      } else if (isS(c)) {
        this.state = S_CLOSE_TAG_SAW_WHITE;
      } else if (c !== EOC) {
        this.fail("disallowed character in closing tag.");
      }
    }
  }, {
    key: "sCloseTagSawWhite",
    value: function sCloseTagSawWhite() {
      switch (this.skipSpaces()) {
        case GREATER:
          this.closeTag();
          break;

        case EOC:
          break;

        default:
          this.fail("disallowed character in closing tag.");
      }
    } // END OF STATE ENGINE METHODS

  }, {
    key: "handleTextInRoot",
    value: function handleTextInRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for performing the ]]> check. A previous version of this code, checked
      // ``this.text`` for the presence of ]]>. It simplified the code but was
      // very costly when character data contained a lot of entities to be parsed.
      //
      // Since we are using a specialized loop, we also keep track of the presence
      // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
      //
      var start = this.i,
          forbiddenState = this.forbiddenState;
      var chunk = this.chunk,
          handler = this.textHandler; // eslint-disable-next-line no-labels, no-restricted-syntax

      scanLoop: // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;

              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);

                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }

              forbiddenState = FORBIDDEN_START; // eslint-disable-next-line no-labels

              break scanLoop;
            }

          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;

            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }

            forbiddenState = FORBIDDEN_START; // eslint-disable-next-line no-labels

            break scanLoop;

          case CLOSE_BRACKET:
            switch (forbiddenState) {
              case FORBIDDEN_START:
                forbiddenState = FORBIDDEN_BRACKET;
                break;

              case FORBIDDEN_BRACKET:
                forbiddenState = FORBIDDEN_BRACKET_BRACKET;
                break;

              case FORBIDDEN_BRACKET_BRACKET:
                break;

              default:
                throw new Error("impossible state");
            }

            break;

          case GREATER:
            if (forbiddenState === FORBIDDEN_BRACKET_BRACKET) {
              this.fail("the string \"]]>\" is disallowed in char data.");
            }

            forbiddenState = FORBIDDEN_START;
            break;

          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }

            start = this.i;
            forbiddenState = FORBIDDEN_START;
            break;

          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            } // eslint-disable-next-line no-labels


            break scanLoop;

          default:
            forbiddenState = FORBIDDEN_START;
        }
      }

      this.forbiddenState = forbiddenState;
    }
  }, {
    key: "handleTextOutsideRoot",
    value: function handleTextOutsideRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for a specialized task. We keep track of the presence of non-space
      // characters in the text since these are errors when appearing outside the
      // document root element.
      var start = this.i;
      var chunk = this.chunk,
          handler = this.textHandler;
      var nonSpace = false; // eslint-disable-next-line no-labels, no-restricted-syntax

      outRootLoop: // eslint-disable-next-line no-constant-condition
      while (true) {
        var code = this.getCode();

        switch (code) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;

              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);

                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              } // eslint-disable-next-line no-labels


              break outRootLoop;
            }

          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;

            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }

            nonSpace = true; // eslint-disable-next-line no-labels

            break outRootLoop;

          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }

            start = this.i;
            break;

          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            } // eslint-disable-next-line no-labels


            break outRootLoop;

          default:
            if (!isS(code)) {
              nonSpace = true;
            }

        }
      }

      if (!nonSpace) {
        return;
      } // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
      // to avoid reporting errors for every single character that is out of
      // place.


      if (!this.sawRoot && !this.reportedTextBeforeRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextBeforeRoot = true;
      }

      if (this.closedRoot && !this.reportedTextAfterRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextAfterRoot = true;
      }
    }
  }, {
    key: "pushAttribNS",
    value: function pushAttribNS(name, value) {
      var _a;

      var _this$qname = this.qname(name),
          prefix = _this$qname.prefix,
          local = _this$qname.local;

      var attr = {
        name: name,
        prefix: prefix,
        local: local,
        value: value
      };
      this.attribList.push(attr); // eslint-disable-next-line no-unused-expressions

      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);

      if (prefix === "xmlns") {
        var trimmed = value.trim();

        if (this.currentXMLVersion === "1.0" && trimmed === "") {
          this.fail("invalid attempt to undefine prefix in XML 1.0");
        }

        this.topNS[local] = trimmed;
        nsPairCheck(this, local, trimmed);
      } else if (name === "xmlns") {
        var _trimmed = value.trim();

        this.topNS[""] = _trimmed;
        nsPairCheck(this, "", _trimmed);
      }
    }
  }, {
    key: "pushAttribPlain",
    value: function pushAttribPlain(name, value) {
      var _a;

      var attr = {
        name: name,
        value: value
      };
      this.attribList.push(attr); // eslint-disable-next-line no-unused-expressions

      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
    }
    /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */

  }, {
    key: "end",
    value: function end() {
      var _a, _b;

      if (!this.sawRoot) {
        this.fail("document must contain a root element.");
      }

      var tags = this.tags;

      while (tags.length > 0) {
        var tag = tags.pop();
        this.fail("unclosed tag: ".concat(tag.name));
      }

      if (this.state !== S_BEGIN && this.state !== S_TEXT) {
        this.fail("unexpected end.");
      }

      var text = this.text;

      if (text.length !== 0) {
        // eslint-disable-next-line no-unused-expressions
        (_a = this.textHandler) === null || _a === void 0 ? void 0 : _a.call(this, text);
        this.text = "";
      }

      this._closed = true; // eslint-disable-next-line no-unused-expressions

      (_b = this.endHandler) === null || _b === void 0 ? void 0 : _b.call(this);

      this._init();

      return this;
    }
    /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */

  }, {
    key: "resolve",
    value: function resolve(prefix) {
      var _a, _b;

      var uri = this.topNS[prefix];

      if (uri !== undefined) {
        return uri;
      }

      var tags = this.tags;

      for (var index = tags.length - 1; index >= 0; index--) {
        uri = tags[index].ns[prefix];

        if (uri !== undefined) {
          return uri;
        }
      }

      uri = this.ns[prefix];

      if (uri !== undefined) {
        return uri;
      }

      return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
    }
    /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */

  }, {
    key: "qname",
    value: function qname(name) {
      // This is faster than using name.split(":").
      var colon = name.indexOf(":");

      if (colon === -1) {
        return {
          prefix: "",
          local: name
        };
      }

      var local = name.slice(colon + 1);
      var prefix = name.slice(0, colon);

      if (prefix === "" || local === "" || local.includes(":")) {
        this.fail("malformed name: ".concat(name, "."));
      }

      return {
        prefix: prefix,
        local: local
      };
    }
  }, {
    key: "processAttribsNS",
    value: function processAttribsNS() {
      var _a;

      var attribList = this.attribList;
      var tag = this.tag;
      {
        // add namespace info to tag
        var _this$qname2 = this.qname(tag.name),
            prefix = _this$qname2.prefix,
            local = _this$qname2.local;

        tag.prefix = prefix;
        tag.local = local;
        var uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";

        if (prefix !== "") {
          if (prefix === "xmlns") {
            this.fail("tags may not have \"xmlns\" as prefix.");
          }

          if (uri === "") {
            this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
            tag.uri = prefix;
          }
        }
      }

      if (attribList.length === 0) {
        return;
      }

      var attributes = tag.attributes;
      var seen = new Set(); // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting

      var _iterator = _createForOfIteratorHelper(attribList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          var name = attr.name,
              _prefix = attr.prefix,
              _local = attr.local;

          var _uri = void 0;

          var eqname = void 0;

          if (_prefix === "") {
            _uri = name === "xmlns" ? XMLNS_NAMESPACE : "";
            eqname = name;
          } else {
            _uri = this.resolve(_prefix); // if there's any attributes with an undefined namespace,
            // then fail on them now.

            if (_uri === undefined) {
              this.fail("unbound namespace prefix: ".concat(JSON.stringify(_prefix), "."));
              _uri = _prefix;
            }

            eqname = "{".concat(_uri, "}").concat(_local);
          }

          if (seen.has(eqname)) {
            this.fail("duplicate attribute: ".concat(eqname, "."));
          }

          seen.add(eqname);
          attr.uri = _uri;
          attributes[name] = attr;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.attribList = [];
    }
  }, {
    key: "processAttribsPlain",
    value: function processAttribsPlain() {
      var attribList = this.attribList; // eslint-disable-next-line prefer-destructuring

      var attributes = this.tag.attributes;

      var _iterator2 = _createForOfIteratorHelper(attribList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
              name = _step2$value.name,
              value = _step2$value.value;

          if (attributes[name] !== undefined) {
            this.fail("duplicate attribute: ".concat(name, "."));
          }

          attributes[name] = value;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.attribList = [];
    }
    /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */

  }, {
    key: "openTag",
    value: function openTag() {
      var _a;

      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = false; // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions

      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      tags.push(tag);
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */

  }, {
    key: "openSelfClosingTag",
    value: function openSelfClosingTag() {
      var _a, _b, _c;

      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = true; // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions

      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag); // eslint-disable-next-line no-unused-expressions

      (_b = this.closeTagHandler) === null || _b === void 0 ? void 0 : _b.call(this, tag);
      var top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;

      if (top === null) {
        this.closedRoot = true;
      }

      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */

  }, {
    key: "closeTag",
    value: function closeTag() {
      var tags = this.tags,
          name = this.name; // Our state after this will be S_TEXT, no matter what, and we can clear
      // tagName now.

      this.state = S_TEXT;
      this.name = "";

      if (name === "") {
        this.fail("weird empty close tag.");
        this.text += "</>";
        return;
      }

      var handler = this.closeTagHandler;
      var l = tags.length;

      while (l-- > 0) {
        var tag = this.tag = tags.pop();
        this.topNS = tag.ns; // eslint-disable-next-line no-unused-expressions

        handler === null || handler === void 0 ? void 0 : handler(tag);

        if (tag.name === name) {
          break;
        }

        this.fail("unexpected close tag.");
      }

      if (l === 0) {
        this.closedRoot = true;
      } else if (l < 0) {
        this.fail("unmatched closing tag: ".concat(name, "."));
        this.text += "</".concat(name, ">");
      }
    }
    /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */

  }, {
    key: "parseEntity",
    value: function parseEntity(entity) {
      // startsWith would be significantly slower for this test.
      // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
      if (entity[0] !== "#") {
        var defined = this.ENTITIES[entity];

        if (defined !== undefined) {
          return defined;
        }

        this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
        return "&".concat(entity, ";");
      }

      var num = NaN;

      if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) {
        num = parseInt(entity.slice(2), 16);
      } else if (/^#[0-9]+$/.test(entity)) {
        num = parseInt(entity.slice(1), 10);
      } // The character reference is required to match the CHAR production.


      if (!this.isChar(num)) {
        this.fail("malformed character entity.");
        return "&".concat(entity, ";");
      }

      return String.fromCodePoint(num);
    }
  }]);

  return SaxesParser;
}();

exports.SaxesParser = SaxesParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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